import { IFilter } from "../../../../context/filters";
import { ISelectedFilterMap } from "../../../../context/selectedFilters";
import { IEntityFilterItem } from "../../BaseFilter";
import { toggleFilterFromUrl } from "./buildFilterParams";
import { isFilterSelected } from "./isFilterSelected";
import { getConfig } from "../../../../../../../config/app";

const getCompanySlug = (countryCode: string): string | null => {
  switch (countryCode) {
    case "br":
      return "companhia";
    case "cl":
    case "co":
      return "compania";
    default:
      return null;
  }
};

export const isTravelInsuranceCompanyFilter = (
  countryCode: string,
  entityFilter: IEntityFilterItem
): boolean => entityFilter.entity.slug === getCompanySlug(countryCode);

export const getTravelCompanyLinkProps = (
  countryCode: string,
  businessUnitSlug: string,
  filter: IFilter,
  title: string
) => ({
  title,
  url: `${getConfig(`urls.${countryCode}.home`)}/${businessUnitSlug}/${getCompanySlug(
    countryCode
  )}/${filter.slug}`
});

export const getFilterLinkProps = (
  basePath: string,
  selectedFilterMap: ISelectedFilterMap,
  entityFilter: IEntityFilterItem,
  filter: IFilter,
  title: string
) => {
  const isSelected = isFilterSelected(selectedFilterMap, entityFilter, filter);
  const url = `${basePath}${toggleFilterFromUrl(selectedFilterMap, entityFilter, filter)}`;
  return {
    highlight: isSelected,
    title: `${title} (${filter.count})`,
    url
  };
};
